"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetState = exports.AssetClass = exports.SearchToSymbolConversion = exports.SymbolType = exports.CountryCode = exports.View = void 0;
var search_1 = require("./search");
Object.defineProperty(exports, "View", { enumerable: true, get: function () { return search_1.View; } });
var constants_1 = require("../../constants");
Object.defineProperty(exports, "CountryCode", { enumerable: true, get: function () { return constants_1.CountryCode; } });
var SymbolType;
(function (SymbolType) {
    SymbolType["CUSIP"] = "CUSIP";
    SymbolType["ISIN"] = "IssueISIN";
    SymbolType["SEDOL"] = "SEDOL";
    SymbolType["RIC"] = "RIC";
    SymbolType["Ticker"] = "TickerSymbol";
    SymbolType["LipperId"] = "FundClassLipperID";
    SymbolType["IMO"] = "IMO";
    SymbolType["OAPermId"] = "IssuerOAPermID";
    SymbolType["Description"] = "DocumentTitle";
})(SymbolType || (exports.SymbolType = SymbolType = {}));
exports.SearchToSymbolConversion = {
    CUSIP: 'CUSIP',
    IssueISIN: 'ISIN',
    SEDOL: 'SEDOL',
    RIC: 'RIC',
    TickerSymbol: 'Ticker',
    FundClassLipperID: 'LipperId',
    IMO: 'IMO',
    IssuerOAPermID: 'OAPermId',
    DocumentTitle: 'Description',
};
var AssetClass;
(function (AssetClass) {
    AssetClass["Commodities"] = "Commodities";
    AssetClass["EquityOrIndexOptions"] = "EquityOrIndexOptions";
    AssetClass["BondAndSTIRFuturesAndOptions"] = "BondAndSTIRFuturesAndOptions";
    AssetClass["Warrants"] = "Warrants";
    AssetClass["Equities"] = "Equities";
    AssetClass["Indices"] = "Indices";
    AssetClass["EquityIndexFutures"] = "EquityIndexFutures";
    AssetClass["Funds"] = "Funds";
    AssetClass["Certificates"] = "Certificates";
    AssetClass["Bonds"] = "Bonds";
    AssetClass["ReverseConvertible"] = "ReverseConvertible";
    AssetClass["MiniFuture"] = "MiniFuture";
    AssetClass["FXAndMoney"] = "FXAndMoney";
})(AssetClass || (exports.AssetClass = AssetClass = {}));
var AssetState;
(function (AssetState) {
    AssetState["Active"] = "Active";
    AssetState["Inactive"] = "Inactive";
})(AssetState || (exports.AssetState = AssetState = {}));
